(ns ui.editors.card.associations.model
  (:require
   [common.localization :as loc]
   [clojure.string :as string]
   [common.schema.entity-type-names :as entity-type-names]
   [common.schema.associations :as associations-schema]))

;; FIXME: These must be dynamic based on account permissions
(def all-associated-entity-type-options
  (->>
   [:entity.type/person
    :entity.type/holding
    :entity.type/oppo
    :entity.type/company]
   (mapv (fn [entity-type]
           {:value entity-type
            :label (loc/tr entity-type)}))
   (sort-by :label)))

(def entity-type-default-table-column-fields
  {:entity.type/person [:person/first-name
                        :person/last-name
                        :person/universal-email-address]
   :entity.type/holding [:holding/name]
   :entity.type/oppo [:oppo/name]
   :entity.type/company [:asset/name]})

(def entity-type-default-sort-by-field
  {:entity.type/person :person/first-name
   :entity.type/holding :holding/name
   :entity.type/oppo :oppo/name
   :entity.type/company :asset/name})

(defn create-default-table-config
  [{:keys [card-entity-type associated-entity-type]}]
  {:entity-type associated-entity-type
   :title (loc/tr :linked-associations [(-> associated-entity-type
                                            (entity-type-names/get-plural :en)
                                            (string/lower-case))])
   :sort-by-field (get entity-type-default-sort-by-field associated-entity-type)
   :columns (->> [:association-type :association-comment]
                 (concat (get entity-type-default-table-column-fields associated-entity-type))
                 (mapv (fn [field]
                         {:field field})))
   :entity-peek {:visible-fields-strategy :all-fields}})
